import { useDatabase } from "@nozbe/watermelondb/hooks";
import { useEffect, useState } from "react";
import StockCount from "../../../../utilities/data/model/StockCount";
import { CountProductModalRootContext } from "../../../../utilities/stock-count/context";

export interface CountProductModalRootProviderProps {
  stockCountId?: string;
  children?: React.ReactNode;
}

export function CountProductModalRootProvider({
  stockCountId,
  children,
}: CountProductModalRootProviderProps) {
  const database = useDatabase();
  const [stockCount, setStockCount] = useState<StockCount | undefined>(
    undefined
  );

  async function fetchStockCount(id: string) {
    return database.collections.get<StockCount>("stock_counts").find(id);
  }

  useEffect(() => {
    if (!stockCountId) {
      return setStockCount(undefined);
    }
    fetchStockCount(stockCountId)
      .then((fetchedStockCount) => {
        setStockCount(fetchedStockCount);
      })
      .catch(() => {
        setStockCount(undefined);
      });
  }, [stockCountId]);

  if (!stockCount) return null;

  return (
    <CountProductModalRootContext.Provider value={{ stockCount }}>
      {children}
    </CountProductModalRootContext.Provider>
  );
}
